<script lang="ts">
	import type { Snippet } from 'svelte';

	let {
		imageDark,
		imageLight,
		children,
		flip = false
	}: {
		imageDark: string;
		imageLight: string;
		children: Snippet;
		flip?: boolean;
	} = $props();
</script>

<div class={['flex gap-1.5 items-center text-left', flip && 'flex-row-reverse']}>
	<img src={imageDark} alt="" class="w-full h-auto hidden dark:flex max-w-[40vw]" />
	<img src={imageLight} alt="" class="w-full h-auto flex dark:hidden max-w-[40vw]" />

	<div class="text-balance">
		{@render children()}
	</div>
</div>
